<script>
	import { onMount } from "svelte";
	import { validator } from "../validation";

	import TextInput from "./TextInput.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import YesNoUnsureGroup from "./YesNoUnsureGroup.svelte";
	import AddButton from "./buttons/AddButton.svelte";

	import model from "../stores/modelStore";
	import SuperFund from "../models/SuperFund";

	import registrationTypes from "../config/registrationTypes";

	export let disabled = null;
	export let required = true;
	export let superFunds = [];

	const addFund = () => {
		var errors = isValid();
		if (errors.length !== 0) {
			return;
		}

		superFunds = [...superFunds, new SuperFund()];
	};

	const deleteFund = (index) => {
		if (superFunds.length <= 1) return;
		superFunds.splice(index, 1);
		superFunds = [...superFunds];
	};

	export const isValid = () => {
		return $validator.validateAll(document.querySelector(`#superFunds`));
	};

	onMount(() => {
		if (superFunds && superFunds.length < 1) {
			superFunds = [new SuperFund()];
		}
	});

	let haveIncomeProtectionInsuranceLabel = "";
	$: {
		if ($model.registrationType) {
			if ($model.registrationType === registrationTypes.types.Myself.value) {
				haveIncomeProtectionInsuranceLabel = "Did you have income protection insurance under this fund?";
			} else {
				haveIncomeProtectionInsuranceLabel = "Did they have income protection insurance under this fund?";
			}
		}
	}
</script>

<div id="superFunds">
	<p><strong>Default Fund Details</strong></p>

	{#each superFunds as fund, i (fund)}
		<div class="shadowed-box">
			<div class="fund">
				<FormRow>
					<FormColumn>
						<TextInput
							{required}
							{disabled}
							label="Employer Name"
							bind:value={fund.employerName}
							id="memberNumber_{i}"
						/>
					</FormColumn>
				</FormRow>

				<FormRow>
					<FormColumn>
						<TextInput
							{required}
							{disabled}
							label="Super Fund"
							bind:value={fund.fundName}
							id="fundName_{i}"
						/>
					</FormColumn>
				</FormRow>

				<FormRow>
					<FormColumn>
						<YesNoUnsureGroup
							{required}
							{disabled}
							name="haveIncomeProtection{i}"
							label={haveIncomeProtectionInsuranceLabel}
							bind:value={fund.haveIncomeProtection}
						/>
					</FormColumn>
				</FormRow>
				<div class="confirmation-hide">
					<button on:click|preventDefault={deleteFund(i)} class="delete" title="Delete Fund">
						<i class="fas fa-trash"></i>{`${i + 1} of ${superFunds.length}`}
					</button>
				</div>
			</div>
		</div>
	{/each}

	<div class="confirmation-hide" style="margin-top: 26px;">
		<AddButton on:add={addFund}>Add another employer or default fund</AddButton>
	</div>
</div>

<style>
	.fund {
		position: relative;
		margin-right: 40px;
	}

	.delete {
		border: none;
		outline: none;
		background-color: transparent;
		position: absolute;
		top: -10px;
		right: 0px;
		font-size: 1.1rem;
		color: var(--color-primary);
	}
</style>
